import { TOKEN_KEY, USER_DETAILS_KEY, SERVER_ORIGIN } from "./consts";

/* ---------------------------------------------------------------------- */
/*  Утилиты                                                                */
/* ---------------------------------------------------------------------- */

export const getCourseLabel = (course) => `${course} курс`;

export const setToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

export const setUserDetails = (userDetails) => {
  if (userDetails) {
    sessionStorage.setItem(USER_DETAILS_KEY, JSON.stringify(userDetails));
  } else {
    sessionStorage.removeItem(USER_DETAILS_KEY);
  }
};

export const getUserDetails = () => {
  let userDetails = null;

  const userDetailsStr = sessionStorage.getItem(USER_DETAILS_KEY);
  if (userDetailsStr) {
    try {
      userDetails = JSON.parse(userDetailsStr);
    } catch (error) {
      console.error("Ошибка парсинга userDetails", error);
    }
  }

  return userDetails;
};

export const callApi = async ({
  method,
  path,
  queryParams,
  body,
  needAuth,
}) => {
  try {
    const params = queryParams ? `?${queryParams.toString()}` : "";

    const url = `${SERVER_ORIGIN}/${path}${params}`;

    const headers = {
      "Content-Type": "application/json",
    };
    if (needAuth) {
      headers.Authorization = `Bearer ${sessionStorage.getItem(TOKEN_KEY)}`;
    }

    const response = await fetch(url, { method, body, headers });
    if (!response.ok) {
      const json = await response.json();
      return {
        error: `Response status: ${response.status}`,
        status: response.status,
        message: json.message,
        details: json.details,
      };
    }

    if (response.status != 204) {
      const json = await response.json();
      return { response: json };
    }
    return {};
  } catch (error) {
    return { error: error.message };
  }
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString();
};

export const formatDT = (datetime) =>
  datetime ? new Date(datetime).toLocaleString() : undefined;

export const getPositiveInteger = (stringValue) => {
  const intValue = parseInt(stringValue || "0", 10);
  return intValue > 0 ? intValue : 1;
};

const getNewPractice = (practical, i) => ({
  number: practical.number,
  variant: (i % practical.variantsCount) + 1,
  variantsCount: practical.variantsCount,
});

export const getVariantsMapping = (practicals, i) =>
  practicals.map((practical) => getNewPractice(practical, i));

export const getNewPractices = (i, practices, practicals) =>
  practicals.map((practical) => {
    const practice = practices.find((p) => p.number === practical.number);
    if (practice?.variantsCount === practical.variantsCount) {
      return practice;
    } else {
      return getNewPractice(practical, i);
    }
  });

export const updateSubgroupVariants = (
  subgroupsCount,
  practicals,
  setSubgroupVariants,
) => {
  const newSubgroupVariants = Array.from(
    { length: subgroupsCount },
    (_, i) => ({
      subgroupNumber: i + 1,
      practices: getVariantsMapping(practicals, i),
    }),
  );
  setSubgroupVariants(newSubgroupVariants);
};

export const getGroupRequestBody = ({
  course,
  group,
  interactionType,
  practicals,
  students,
  studentVariants,
  subgroupVariants,
  confirmMaterialsDeletion,
}) => {
  const getPayloadPractices = (arr) =>
    arr.map((item) => ({ number: item.number, variant: item.variant }));

  const body = JSON.stringify({
    course,
    group,
    interactionType,
    practicals,
    students: students?.map((elem) => ({
      studentId: elem.studentId,
      subgroupNumber: elem.subgroupNumber,
    })),
    studentVariants: studentVariants?.map((v) => ({
      studentId: v.studentId,
      practices: getPayloadPractices(v.practices),
    })),
    subgroupVariants: subgroupVariants?.map((v) => ({
      subgroupNumber: v.subgroupNumber,
      practices: getPayloadPractices(v.practices),
    })),
    confirmMaterialsDeletion,
  });

  return body;
};
